<template>
  <LayoutAdmin @click="activeDropdown = false" :active-periode="activePeriodic">
    <section class="w-full px-8 mt-6 overflow-x-hiden">
      <section class="flex justify-between">
        <section class="flex items-center">
          <h1 class="text-2xl">Daily Log</h1>
          <ChoiseCompany v-if="!loading.getCompany && optionsCompany.length"
            @selected:company="dataCompany = $event" :options="optionsCompany" :dataCompany="dataCompany" />
        </section>
        <div class="flex">
          <Button class="px-6 py-2 mr-2 text-white rounded bg-primary" @click="modal.showModal = true">Add
            Absensi</Button>
          <Button class="px-6 py-2 mr-2 text-white rounded bg-seagreen">Settings</Button>
          <download-excel class="px-6 py-2 mr-2 text-white rounded bg-seagreen" :data="attendance_filter"
            :fields="json_fields" worksheet="Daily" name="Attendance.xls">
            Export Excel
          </download-excel>
        </div>
      </section>
      <section class="flex flex-wrap items-center w-10/12 mt-6">
        <section class="relative">
          <Button class="px-6 py-2 text-sm text-gray-400 duration-300 rounded-full" :class="[
            'bg-white hover:bg-gray-50 hover:text-blue-800',
            filter.date && filter.date !== dateToday()
              ? 'text-primary bg-gray-50'
              : '',
          ]" @click.stop="changeDropdownActive('date')" style="min-width: 80px; min-height: 30px">
            {{ filter.date === dateToday() ? "Today" : filter.date }}
            <font-awesome-icon icon="fa-xmark" class="ml-3 text-primary" v-if="filter.date && filter.date !== dateToday()"
              @click.stop="
                handleFilterDate((filter.date = dateToday()));
              activeDropdown = '';
              " />
          </Button>
          <Transition enter-active-class="animated fadeInDown" leave-active-class="animated fadeOutUp">
            <Calender class="absolute top-10 left-0 z-20 mt-2.5" v-if="activeDropdown === 'date'"
              @selected="handleFilterDate((filter.date = $event))" />
          </Transition>
        </section>

        <Dropdown title="Departement" :showDropdown="activeDropdown === 'departement'"
          @update:activeDropdown="changeDropdownActive('departement')" :options="departement" property="dep_name"
          @selected="
            handleFilter(
              filter.date,
              (filter.departement = $event?._id),
              filter.workshift,
              filter.behavior,
              filter.status,
              filter.employment
            )
            " @clearSelected="
    handleFilter(
      filter.date,
      (filter.departement = $event),
      filter.workshift,
      filter.behavior,
      filter.status,
      filter.employment
    )
    " :selectedOption="filter.departement" />

        <Button
          class="px-6 py-2 text-sm text-gray-400 duration-300 bg-white rounded-full hover:bg-gray-50 hover:text-blue-80"
          style="min-width: 80px; min-height: 30px" :class="isShowPeriod ? 'text-primary bg-gray-50' : null"
          @click="showPeriod">
          Period
          <font-awesome-icon icon="fa-xmark" class="ml-3 text-primary" v-if="isShowPeriod" @click.stop="showPeriod" />
        </Button>
        <Dropdown title="Workshift" :showDropdown="activeDropdown === 'workshift'"
          @update:activeDropdown="changeDropdownActive('workshift')" :options="shifts" property="shift_name" @selected="
            handleFilter(
              filter.date,
              filter.departement,
              (filter.workshift = $event?._id),
              filter.behavior,
              filter.status,
              filter.employment
            )
            " @clearSelected="
    handleFilter(
      filter.date,
      filter.departement,
      (filter.workshift = $event),
      filter.behavior,
      filter.status,
      filter.employment
    )
    " :selectedOption="filter.workshift" />
        <Dropdown title="Behavior" :showDropdown="activeDropdown === 'behavior'"
          @update:activeDropdown="changeDropdownActive('behavior')" :options="['Early', 'Regular', 'Late', 'Very Late']"
          @selected="
            handleFilter(
              filter.date,
              filter.departement,
              filter.workshift,
              (filter.behavior = $event),
              filter.status,
              filter.employment
            )
            " @clearSelected="
    handleFilter(
      filter.date,
      filter.departement,
      filter.workshift,
      (filter.behavior = $event),
      filter.status,
      filter.employment
    )
    " :selectedOption="filter.behavior" />
        <Dropdown title="Status" :showDropdown="activeDropdown === 'type'"
          @update:activeDropdown="changeDropdownActive('type')" :options="[
            'Attendance',
            'Absent',
            'Off Day',
            'Cuti Tahunan (Paid)',
            'Cuti Menikah (Paid)',
            'Izin Sakit (Paid)',
            'Izin Khusus (Paid)',
            'Izin Khusus (Unpaid)',
            'Cuti Bersama',
          ]" @selected="
  handleFilter(
    filter.date,
    filter.departement,
    filter.workshift,
    filter.behavior,
    (filter.status = $event),
    filter.employment
  )
  " @clearSelected="
    handleFilter(
      filter.date,
      filter.departement,
      filter.workshift,
      filter.behavior,
      (filter.status = $event),
      filter.employment
    )
    " :selectedOption="filter.status" />
        <Dropdown title="Employment" :showDropdown="activeDropdown === 'employee'"
          @update:activeDropdown="changeDropdownActive('employee')" :options="employment" property="emp_fullname"
          :selectedOption="filter.employment" @selected="
            handleFilter(
              filter.date,
              filter.departement,
              filter.workshift,
              filter.behavior,
              filter.status,
              (filter.employment = $event?._id)
            )
            " @clearSelected="
    handleFilter(
      filter.date,
      filter.departement,
      filter.workshift,
      filter.behavior,
      filter.status,
      (filter.employment = $event)
    )
    " />
      </section>
      <section class="w-full">
        <section class="flex justify-between p-4 mt-6" v-if="isShowPeriod">
          <Periodic :month-selected="monthSelected.text" :years-selected="yearsSelected"
            @on-previous-month="previousMonth" @on-next-month="nextMonth" />
        </section>
        <section class="relative">
          <section class="relative w-full overflow-x-auto custom-scrollbar" :class="loading.getAttendance ? 'h-96' : ''">
            <table class="w-full pb-4 mt-6 bg-white min-w-max" @click="showActions = null">
              <thead class="text-gray-400 bg-white border-b border-gray-200">
                <tr>
                  <th class="text-sm text-left">Profile</th>
                  <th class="text-sm text-left">Attendance Date</th>
                  <th class="text-sm text-left">Clock In</th>
                  <th class="text-sm text-left">Clock out</th>
                  <th class="text-sm text-left">Status</th>
                  <th class="text-sm text-left">Behaviour</th>
                  <th class="text-sm text-left">Type</th>
                  <th class="text-sm text-left">Total Hours</th>
                  <th class="text-sm text-left">Break</th>
                  <th class="text-sm text-left">Orthers Break</th>
                  <th class="text-sm text-left">Deducation</th>
                  <th class="text-sm text-left">Actions</th>
                </tr>
              </thead>
              <tbody v-if="!loading.addAttendance">
                <tr class="border-b" v-for="(attedance, i) in attendance_filter" :key="i">
                  <td class="flex items-center p-3 text-sm">
                    <div class="flex items-center justify-center w-12 h-12 rounded-full bg-zinc-400">
                      <h2 class="text-white text-md">
                        {{
                          attedance?.emp_id?.emp_fullname.substr(0, 1) +
                          attedance?.emp_id?.emp_fullname.substr(
                            attedance?.emp_id?.emp_fullname.indexOf(" ") + 1,
                            1
                          )
                        }}
                      </h2>
                    </div>
                    <div class="ml-5">
                      <h1 class="text-base text-blue-400">
                        <router-link :to="`/employee/${attedance?.emp_id?._id}`">{{ attedance?.emp_id?.emp_fullname
                        }}</router-link>
                      </h1>
                      <p class="mb-1 text-sm text-gray-600">
                        {{ attedance?.emp_id?.emp_depid?.dep_name }}
                      </p>
                      <p class="text-xs text-gray-400">
                        {{ attedance?.shift_id?.shift_name }} ({{
                          attedance?.workhours_in
                        }}
                        - {{ attedance?.workhours_out }})
                      </p>
                    </div>
                  </td>
                  <td class="p-3 text-sm">
                    <p class="text-sm text-gray-400">
                      {{ attedance?.attendance_date }}
                    </p>
                  </td>
                  <td class="p-3 text-sm">
                    <p class="text-sm text-gray-400">
                      {{ attedance?.clock_in }}
                    </p>
                  </td>

                  <td class="p-3 text-sm">
                    <p class="text-sm text-gray-400">
                      {{ attedance?.clock_out }}
                    </p>
                  </td>
                  <td class="p-3 text-sm">
                    <p class="text-sm" :class="attedance?.attendance_status === 'Absent'
                      ? 'text-red-500'
                      : ''
                      ">
                      {{ attedance?.attendance_status }}
                    </p>
                  </td>
                  <td class="p-3 text-sm">
                    <p v-if="attedance?.behavior_at !== '-'"
                      class="flex items-center justify-center w-24 py-1 text-sm text-white rounded-full"
                      :class="backgroundBehavior(attedance?.behavior_at)">
                      {{ attedance?.behavior_at }}
                    </p>
                    <p v-else class="flex items-center justify-center w-24 py-1 text-gray-400 rounded-full">
                      {{ attedance?.behavior_at }}
                    </p>
                  </td>
                  <td class="p-3 text-sm">
                    <p class="text-sm text-gray-400">{{ attedance?.type }}</p>
                  </td>
                  <td class="p-3 text-sm">
                    <p class="text-sm text-gray-400">
                      {{ attedance?.workhours }}
                    </p>
                  </td>
                  <td class="p-3 text-sm">
                    <p class="text-sm text-gray-400">
                      Break out : {{ attedance?.break_out }}
                    </p>
                    <p class="text-sm text-gray-400">
                      Break In : {{ attedance?.break_in }}
                    </p>
                  </td>
                  <td class="p-3 text-sm">
                    <p class="text-sm text-gray-400 underline">
                      View orthers Break
                    </p>
                  </td>
                  <td class="p-3 text-sm">
                    <router-link to="/attedance/detail">
                      <p class="text-sm text-gray-400 underline">
                        View Potongan
                      </p>
                    </router-link>
                  </td>
                  <td class="relative p-3 text-right">
                    <Button class="p-3 rotate-90 rounded-full shadow-none hover:bg-blue-100 text-primary"
                      @click.stop="showActions = i">
                      <font-awesome-icon icon="fa-ellipsis" />
                    </Button>
                    <div class="absolute top-0 text-left bg-white rounded-md shadow-md right-20 md:w-max md:h-max"
                      v-if="showActions === i">
                      <ul class="text-sm cursor-pointer">
                        <li class="px-4 py-2 hover:bg-gray-100 hover:text-blue-400"
                          @click="handleDetailAttendance(attedance)">
                          Edit
                        </li>
                        <li class="px-4 py-2 text-red-500 hover:bg-gray-100 hover:text-red-400"
                          @click="handleDeleteAttendance(attedance?._id)">
                          Delete
                        </li>
                      </ul>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </section>
          <Loading v-if="loading.getAttendance" />
          <NoDataShowing v-if="!loading.getAttendance && attendance_filter.length === 0" />
        </section>
        <p class="mt-5 mb-3 text-sm text-gray-300">
          Showing 1 to 10 items of 11
        </p>
      </section>
      <section class="flex justify-between my-6"></section>
    </section>
    <Modal :title="`${modal.modeEdit ? 'Edit' : 'Add'} Attendance`" :showModal="modal.showModal" @close="
      modal.showModal = false;
    clearInputValue();
    modal.modeEdit = false;
    ">
      <template #header>
        <ChoiseCompany v-if="optionsCompany.length" @selected:company="dataCompany = $event"
          :options="optionsCompany" :dataCompany="dataCompany" />
      </template>
      <section @click="
        modal.showSelect = false;
      modal.showTime = false;
      ">
        <SelectSearch label="Employee" :options="employment" :isOpen="modal.showSelect === 'employment'"
          @handleShowSelect="() => (modal.showSelect = 'employment')" class="flex-col" property="emp_fullname"
          input_class="w-full mt-2" label_class="w-full text-black" @selected="data.emp_id = $event"
          :selectedOption="data.emp_id" />
        <Input type="date" class="flex-col mt-4" label="Date Clock in Attendance" label_class="w-full" input_class="mt-2"
          @change="data.attendance_date = $event" :value="data?.attendance_date" />
        <SelectSearch label="Status" :options="[
          'Attendance',
          'Absent',
          'Off Day',
          'Cuti Tahunan (Paid)',
          'Cuti Menikah (Paid)',
          'Izin Sakit (Paid)',
          'Izin Khusus (Paid)',
          'Izin Khusus (Unpaid)',
          'Cuti Bersama',
        ]" :isOpen="modal.showSelect === 'status'" @handleShowSelect="() => (modal.showSelect = 'status')"
          class="flex-col" input_class="w-full mt-2" label_class="w-full text-black"
          @selected="data.attendance_status = $event" :selectedOption="data?.attendance_status" v-if="modal.modeEdit" />
        <SelectSearch label="Attendance Shift" :options="shifts" property="shift_desc"
          :isOpen="modal.showSelect === 'shift'" @handleShowSelect="() => (modal.showSelect = 'shift')" class="flex-col"
          input_class="w-full mt-2" label_class="w-full text-black" @selected="data.attendance_shift = $event"
          :selectedOption="data?.attendance_shift" v-if="modal.modeEdit" />
        <section class="flex items-center justify-between my-4">
          <InputTime label="Clock In" :isOpen="modal.showTime === 'in'" @showTime="modal.showTime = 'in'"
            :hourValue="modal.time_clockin.hour" :minuteValue="modal.time_clockin.minute"
            @selected-hour="modal.time_clockin.hour = $event" @selected-minute="modal.time_clockin.minute = $event" />
          <InputTime label="Clock Out" :isOpen="modal.showTime === 'out'" @showTime="modal.showTime = 'out'"
            :hourValue="modal.time_clockout.hour" :minuteValue="modal.time_clockout.minute"
            @selected-hour="modal.time_clockout.hour = $event" @selected-minute="modal.time_clockout.minute = $event" />
        </section>
        <Input type="date" class="flex-col mt-4" label="Date Clock out Attendance" label_class="w-full" input_class="mt-2"
          @change="data.attendance_date_out = $event" :value="data?.attendance_date_out" />
        <section class="flex items-center justify-between my-4">
          <InputTime label="Break In" :isOpen="modal.showTime === 'bin'" @showTime="modal.showTime = 'bin'"
            :hourValue="modal.time_breakin.hour" :minuteValue="modal.time_breakin.minute"
            @selected-hour="modal.time_breakin.hour = $event" @selected-minute="modal.time_breakin.minute = $event" />
          <InputTime label="Break Out" :isOpen="modal.showTime === 'bout'" @showTime="modal.showTime = 'bout'"
            :hourValue="modal.time_breakout.hour" :minuteValue="modal.time_breakout.minute"
            @selected-hour="modal.time_breakout.hour = $event" @selected-minute="modal.time_breakout.minute = $event" />
        </section>
        <label class="text-sm">Reason Note</label>
        <textarea rows="4" class="w-full py-4 mt-2 border outline-primary" v-model="data.attendance_reason"
          v-if="modal.modeEdit">
        </textarea>
      </section>
      <template #footer>
        <section class="flex justify-between w-52">
          <Button class="w-24 py-2 text-white bg-gray-400 rounded-md">
            Cancel
          </Button>
          <Button class="w-24 py-2 text-white bg-green-500 rounded-md" :disabled="data.emp_id === '' ||
            data.attendance_date === '' ||
            data.attendance_date_out === '' ||
            modal.time_clockin.hour === '' ||
            loading.addAttendance
            " @click="handleAddAttendance" v-if="!modal.modeEdit">
            Save
          </Button>
          <Button v-else class="w-24 py-2 text-white bg-green-500 rounded-md" :disabled="data.emp_id === '' ||
            data.attendance_date === '' ||
            data.attendance_date_out === '' ||
            (modal.time_clockin.hour === '' &&
              data.attendance_status === 'Attendance') ||
            loading.addAttendance
            " @click="handleEditAttendance">
            Edit
          </Button>
        </section>
      </template>
    </Modal>
  </LayoutAdmin>
</template>

<script>
import LayoutAdmin from "../../components/Layout/Admin.vue";
import Button from "../../components/Button.vue";
import Dropdown from "../../components/Dropdown.vue";
import Modal from "../../components/Modal.vue";
import InputTime from "@/components/InputTime.vue";
import Input from "@/components/Input.vue";
import ChoiseCompany from "@/components/ChoiseCompany.vue";
import { GetAllCompanyEmployeeOptionsAPI } from "@/actions/company";
import decryptToken from "@/utils/decryptToken";
import { useToast } from "vue-toastification";
import { GetAllEmployementAPI } from "@/actions/employment";
import SelectSearch from "@/components/Select/SelectSearch.vue";
import {
  AddAttendanceAPI,
  GetAttendanceAPI,
  EditAttendanceAPI,
  DeleteAttendanceAPI,
} from "@/actions/attendance";
import Loading from "@/components/Loading.vue";
import NoDataShowing from "@/components/NoDataShowing.vue";
import { GetDepartementAPI } from "@/actions/departement";
import { GetShiftAPI } from "@/actions/shift";
import { GetPeriodicAttendance } from "@/actions/periodic";
import { GetPeriodicAPI, GetPeriodicActiveAPI } from "@/actions/periodic";
import Calender from "@/components/Calendar";
import Periodic from "@/components/Periodic.vue";
import moment from "moment";
import JsonExcel from "vue-json-excel3";

export default {
  name: "DailyAttedance",
  components: {
    LayoutAdmin,
    Button,
    Dropdown,
    Modal,
    InputTime,
    ChoiseCompany,
    SelectSearch,
    Loading,
    NoDataShowing,
    Input,
    Calender,
    Periodic,
    downloadExcel: JsonExcel
  },
  data() {
    return {
      activeDropdown: "",
      activePeriodic: "-",
      contactEmployee: 0,
      layoutData: "card",
      modal: {
        modeEdit: false,
        showTime: "",
        showModal: false,
        time_clockin: {
          hour: "",
          minute: "00",
        },
        time_clockout: {
          hour: "",
          minute: "00",
        },
        time_breakin: {
          hour: "",
          minute: "00",
        },
        time_breakout: {
          hour: "",
          minute: "00",
        },
      },
      data: {
        emp_id: "",
        id_attendance: "",
        attendance_date: "",
        attendance_date_out: "",
        attendance_status: "",
        attendance_shift: "",
        attendance_reason: "",
      },
      showActions: null,
      attendances: [],
      shifts: [],
      departement: [],
      optionsCompany: [],
      employment: [],
      all_attendance: [],
      attendance_filter: [],
      superAdmin: false,
      dataCompany: {},
      loading: {
        getAttendance: true,
        getCompany: true,
        addAttendance: false,
      },
      filter: {
        date: "",
        departement: "",
        behavior: "",
        status: "",
        workshift: "",
        employment: "",
        period: null,
      },
      periods: [],
      periodics: [],
      periodicId: "",
      monthSelected: {
        number: "",
        text: "",
      },
      isShowPeriod: false,
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      json_fields: {
        "Name": "emp_id.emp_fullname",
        "Shift": "shift_id.shift_name",
        "Shift In": "workhours_in",
        "Shift Out": "workhours_out",
        "Attendance Date": "attendance_date",
        "Clock In": "clock_in",
        "Clock Out": "clock_out",
        "Status	": "attendance_status",
        "Behaviour": "behavior_at",
        "Type": "type",
        "Break Out": "break_out",
        "Break In": "break_in",
        "Break Duration": "count_breakduration",
        "Break Deduction": "break_deduction",
        "Delay": "count_lateduration",
        "Delay Deduction": "delay_deduction",
        "Attendance Deduction": "attendance_deduction",
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ]
    }
  },
  setup() {
    const toast = useToast();
    return { toast };
  },
  computed: {
    yearsSelected() {
      return moment().format("YYYY");
    },
  },
  methods: {
    backgroundBehavior(behavior) {
      return behavior === "Regular"
        ? "bg-green-500"
        : behavior === "Early"
          ? "bg-coral"
          : "bg-red-500";
    },
    handleShowLayoutData() {
      this.layoutData = this.layoutData === "card" ? "table" : "card";
    },
    changeDropdownActive(id) {
      if (this.activeDropdown === id) {
        this.activeDropdown = false;
      } else {
        this.activeDropdown = id;
      }
    },
    async handleDeleteAttendance(id) {
      const response = await DeleteAttendanceAPI(id);
      if (response?.status === 401) {
        this.$router.push("/login");
        this.$store.commit("changeIsLoggedIn", false);
      }
      if (response?.status === 200) {
        const date = this.filter.date ? this.filter.date : this.dateToday();
        this.handleGetAttendance(date);
      }
      this.showMessageStatus(response);
    },
    async handleGetDepartement() {
      const querySuperAdmin = `?company=${this.dataCompany?._id}`;
      const response = await GetDepartementAPI(querySuperAdmin);
      if (response.status === 401) {
        return this.$router.push("/login");
      }
      this.departement = response.data;
    },
    handleFilterDate(date) {
      this.handleGetAttendance(date);
    },
    handleFilter(date, departement, workshift, behavior, status, employment) {
      const newAttendanceProp = this.all_attendance.map((attendance) => ({
        ...attendance,
        emp_depid: attendance?.emp_id?.emp_depid?._id,
        employment: attendance?.emp_id?._id,
        shift: attendance?.shift_id?._id,
      }));
      const filterConditions = [
        { key: "behavior_at", value: behavior },
        { key: "shift", value: workshift },
        { key: "attendance_status", value: status },
        { key: "emp_depid", value: departement },
        { key: "employment", value: employment },
      ];
      const dataFilter = (overtime) =>
        filterConditions.every(
          ({ key, value }) => value == "" || overtime[key] == value
        );
      this.attendance_filter = newAttendanceProp.filter(dataFilter);
      console.log(this.attendance_filter);
    },
    clearInputValue() {
      for (const key in this.data) {
        this.data[key] = "";
      }
      for (const key in this.modal) {
        if (Object.prototype.hasOwnProperty.call(this.modal[key], "hour")) {
          this.modal[key].hour = "";
        }
        if (Object.prototype.hasOwnProperty.call(this.modal[key], "minute")) {
          this.modal[key].minute = "00";
        }
      }
    },
    async getAllCompany() {
      const response = await GetAllCompanyEmployeeOptionsAPI();
      this.optionsCompany = response?.data;
      this.dataCompany = response?.data[0];
      this.loading.getCompany = false;
    },
    async getShift() {
      const queryAdminSuper = `?company_id=${this.dataCompany?._id}`;
      const response = await GetShiftAPI(queryAdminSuper);
      if (response?.status === 401) {
        this.$router.push("/login");
        this.$store.commit("changeIsLoggedIn", false);
      }
      if (response?.status === 200) {
        this.shifts = response?.data;
      }
    },
    showMessageStatus(response) {
      if (response.status === 200) {
        this.toast.success(response?.data?.message);
      } else {
        if (response.data.message) {
          this.toast.error(response?.data?.message);
        }
      }
    },
    async handleAddAttendance() {
      this.loading.addAttendance = true;

      const payload = {
        emp_id: this.data?.emp_id?._id,
        attendance_date: this.data.attendance_date,
        clock_in: `${this.modal.time_clockin?.hour}:${this.modal.time_clockin?.minute}`,
        clock_out: `${this.modal.time_clockout?.hour}:${this.modal.time_clockout?.minute}`,
        break_in: `${this.modal.time_breakin?.hour}:${this.modal.time_breakin?.minute}`,
        break_out: `${this.modal.time_breakout?.hour}:${this.modal.time_breakout?.minute}`,
        attendance_date_out: this.data.attendance_date_out,
      };
      const queryAdminSuper = `?company_id=${this.dataCompany?._id}`;
      const response = await AddAttendanceAPI(queryAdminSuper, payload);
      if (response?.status === 401) {
        this.$router.push("/login");
        this.$store.commit("changeIsLoggedIn", false);
      }
      if (response?.status === 200) {
        // this.clearInputValue();
        this.handleGetAttendance();
        this.modal.showModal = false;
      }
      this.showMessageStatus(response);
      this.loading.addAttendance = false;
    },
    changeFormatDateToInputFormat(date) {
      if (date) {
        const oldDate = date.split("/");
        const newDate = `${oldDate[2]}-${oldDate[0]}-${oldDate[1]}`;
        return newDate;
      }
      return "-";
      // return newDate;
    },
    dateToday() {
      const dateObject = new Date();
      const month = (dateObject.getMonth() + 1).toString().padStart(2, "0");
      const day = dateObject.getDate().toString().padStart(2, "0");
      const year = dateObject.getFullYear();
      return `${year}-${month}-${day}`;
    },
    async handleGetAttendance(date) {
      this.loading.getAttendance = true;
      // const queryAdminSuper = `?company_id=${this.dataCompany?._id}&request_date=${date}`;
      const companyId = this.dataCompany?._id;
      const requestDate = date;
      const periodicId = this.isShowPeriod ? this.periodicId : null;
      const response = await GetAttendanceAPI({
        companyId,
        requestDate,
        periodicId,
      });
      if (response?.status === 401) {
        this.$router.push("/login");
        this.$store.commit("changeIsLoggedIn", false);
      }
      if (response?.status === 200) {
        const filterAttedanceToday = response.data.filter(
          (attedance) => attedance?.attendance_date === this.dateToday()
        );
        this.attendances = filterAttedanceToday.map((attendance) => ({
          ...attendance,
          attendance_date: this.changeFormatDateToInputFormat(
            attendance?.attendance_date
          ),
          attendance_date_out: this.changeFormatDateToInputFormat(
            attendance?.attendance_date_out
          ),
        }));
        this.all_attendance = response.data.map((attendance) => ({
          ...attendance,
          attendance_date: this.changeFormatDateToInputFormat(
            attendance?.attendance_date
          ),
          attendance_date_out: this.changeFormatDateToInputFormat(
            attendance?.attendance_date_out
          ),
        }));
        this.handleFilter(
          (this.filter.date = this.filter.date
            ? this.filter.date
            : this.dateToday()),
          this.filter.departement,
          this.filter.workshift,
          this.filter.behavior,
          this.filter.status,
          this.filter.employment
        );
      }
      this.loading.getAttendance = false;
    },
    getHourMinute(time) {
      if (time !== "-") {
        const timeArray = time.split(" ")[0].split(":");
        return [timeArray[0], timeArray[1]];
      }
      return ["", "00"];
    },
    handleDetailAttendance(attendance) {
      this.modal.modeEdit = true;
      this.modal.showModal = true;
      this.data.id_attendance = attendance?._id;
      this.data.attendance_date = attendance?.attendance_date;
      this.data.attendance_date_out = attendance?.attendance_date_out;
      this.data.attendance_reason = attendance?.attendance_reason;
      this.data.attendance_status = attendance?.attendance_status;
      this.data.attendance_shift = attendance?.shift_id;
      this.data.emp_id = attendance?.emp_id;
      this.modal.time_clockin.hour = this.getHourMinute(
        attendance?.clock_in
      )[0];
      this.modal.time_clockin.minute = this.getHourMinute(
        attendance?.clock_in
      )[1];
      this.modal.time_clockout.hour = this.getHourMinute(
        attendance?.clock_out
      )[0];
      this.modal.time_clockout.minute = this.getHourMinute(
        attendance?.clock_out
      )[1];
      this.modal.time_breakin.hour = this.getHourMinute(
        attendance?.break_in
      )[0];
      this.modal.time_breakin.minute = this.getHourMinute(
        attendance?.break_in
      )[1];
      this.modal.time_breakout.hour = this.getHourMinute(
        attendance?.break_out
      )[0];
      this.modal.time_breakout.minute = this.getHourMinute(
        attendance?.break_out
      )[1];
    },
    async handleEditAttendance() {
      this.loading.addAttendance = true;

      const payload = {
        emp_id: this.data?.emp_id?._id,
        clock_in: `${this.modal.time_clockin?.hour}:${this.modal.time_clockin?.minute}`,
        clock_out: `${this.modal.time_clockout?.hour}:${this.modal.time_clockout?.minute}`,
        break_in: `${this.modal.time_breakin?.hour}:${this.modal.time_breakin?.minute}`,
        break_out: `${this.modal.time_breakout?.hour}:${this.modal.time_breakout?.minute}`,
        attendance_status: this?.data?.attendance_status,
        shift_id: this?.data?.attendance_shift?._id,
        attendance_reason: this.data?.attendance_reason,
      };
      // const queryAdminSuper = `?company_id=${this.dataCompany?._id}`;
      const response = await EditAttendanceAPI(
        this.data.id_attendance,
        payload
      );
      if (response?.status === 401) {
        this.$router.push("/login");
        this.$store.commit("changeIsLoggedIn", false);
      }
      if (response?.status === 200) {
        this.clearInputValue();
        const date = this.filter.date ? this.filter.date : this.dateToday();
        this.handleGetAttendance(date);
        this.modal.showModal = false;
      }
      this.showMessageStatus(response);
      this.loading.addAttendance = false;
    },
    async handleGetEmployement() {
      const querySuperAdmin = `?company=${this.dataCompany?._id}`;
      const response = await GetAllEmployementAPI(querySuperAdmin);
      if (response.status === 401) {
        this.$store.commit("changeIsLoggedIn", false);
        return this.$router.push("/login");
      }
      const getIdNameEmp = response?.data?.map((employment) => ({
        _id: employment?._id,
        emp_fullname: employment?.emp_fullname,
      }));
      this.employment = getIdNameEmp;
    },
    async getPeriodAttendance() {
      const companyId = this.dataCompany?._id;
      if (this.periodicId !== "") {
        const { data, message, success, code } = await GetPeriodicAttendance({
          companyId,
        });
        if (success) {
          this.periods = data;
        } else {
          if (code === 401) {
            return this.$router.push("/login");
          } else {
            this.toast.error(message);
          }
        }
      }
    },
    selectedPeriod(e) {
      this.filter.period = e;
      this.handleGetAttendance(this.filter.period);
    },
    clearSelectedPeriod() {
      this.filter.period = null;
      this.handleGetAttendance(
        this.filter.date ? this.filter.date : this.dateToday()
      );
    },
    async getPeriodic() {
      const companyId = this.dataCompany?._id;
      const querySuperAdmin = `?company_id=${companyId}`;
      const response = await GetPeriodicAPI(querySuperAdmin);
      if (response?.status === 401) {
        this.$router.push("/login");
        this.$store.commit("changeIsLoggedIn", false);
      }

      const periodics = response?.data || [];
      this.periodics = periodics;

      if (!periodics.length) {
        this.periodicId = "";
        this.monthSelected = { number: "", text: "" };
        this.handleGetAttendance(
          this.filter.date ? this.filter.date : this.dateToday()
        );
        return;
      }

      const filterActivePeriodic = periodics.find(
        (period) => period.periodic_status === true
      );

      if (filterActivePeriodic) {
        const indexMonthActive = this.months.indexOf(
          filterActivePeriodic.periodic_month
        );
        this.monthSelected.number =
          indexMonthActive >= 0 ? indexMonthActive : "";
        this.monthSelected.text =
          indexMonthActive >= 0 ? this.months[indexMonthActive] : "";
      } else {
        // Fallback to first item to avoid undefined access
        this.monthSelected.number = "";
        this.monthSelected.text = periodics[0]?.periodic_month || "";
      }

      const periodicByMonthYear = this.periodics.find((period) => {
        return (
          period.periodic_month === this.monthSelected.text &&
          period.periodic_years === this.yearsSelected
        );
      });
      this.periodicId =
        periodicByMonthYear?._id || filterActivePeriodic?._id || "";

      this.getPeriodAttendance();
      this.handleGetAttendance(
        this.filter.date ? this.filter.date : this.dateToday()
      );
    },
    previousMonth() {
      this.monthSelected.number--;
      if (this.monthSelected.number < 0) {
        this.monthSelected.number = 11;
        this.yearSelected--;
      }
      this.monthSelected.text = this.months[this.monthSelected.number];

      const periodicFilter = this.periodics.filter((periodic) => {
        return (
          periodic?.periodic_month === this.monthSelected.text &&
          periodic?.periodic_years === this.yearsSelected
        );
      })[0];
      console.log(periodicFilter);
      if (periodicFilter) {
        this.periodicId = periodicFilter._id;
        this.handleGetAttendance(
          this.filter.date ? this.filter.date : this.dateToday()
        );
      } else {
        this.attendance_filter = [];
      }
    },
    nextMonth() {
      this.monthSelected.number++;
      if (this.monthSelected.number > 11) {
        this.monthSelected.number = 0;
        this.yearSelected++;
      }
      this.monthSelected.text = this.months[this.monthSelected.number];
      const periodicFilter = this.periodics.filter((periodic) => {
        return (
          periodic?.periodic_month === this.monthSelected.text &&
          periodic?.periodic_years === this.yearsSelected
        );
      })[0];
      if (periodicFilter) {
        this.periodicId = periodicFilter._id;
        this.handleGetAttendance(
          this.filter.date ? this.filter.date : this.dateToday()
        );
      } else {
        this.attendance_filter = [];
      }
    },
    async showPeriod() {
      this.isShowPeriod = !this.isShowPeriod;
      if (!this.isShowPeriod) {
        await this.handleGetAttendance(
          this.filter.date ? this.filter.date : this.dateToday()
        );
        return;
      }

      await this.handleGetAttendance();
    },
    async handleGetPeriodicActive() {
      const querySuperAdmin = `?company_id=${this?.dataCompany?._id}`;
      const response = await GetPeriodicActiveAPI(querySuperAdmin);
      if (response?.status === 401) {
        this.$router.push("/login");
        this.$store.commit("changeIsLoggedIn", false);
      }
      console.log(response?.data);
      this.activePeriodic = response?.data?.periodic_month + " (" + response?.data?.periodic_start_date + " to " + response?.data?.periodic_end_date + ")";
    },
  },
  watch: {
    dataCompany: {
      handler: function () {
        this.getShift();
        this.handleGetEmployement();
        this.handleGetDepartement();
        this.getPeriodAttendance();
        this.getPeriodic();
        this.handleGetPeriodicActive();
      },
      deep: true,
    },
  },
  mounted() {
    const payload = decryptToken();
    this.superAdmin =
      payload?.role === "Super Admin" || payload?.role === "Group Admin";
    this.getAllCompany();
  },
};
</script>

<style scoped>
.fadeInDown {
  animation: fadeInDown 0.3s;
}

.fadeOutUp {
  animation: fadeOutUp 0.3s;
}

@keyframes fadeInDown {
  0% {
    transform: translateY(-10%);
    opacity: 0;
  }

  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes fadeOutUp {
  0% {
    transform: translateY(0);
    opacity: 1;
  }

  100% {
    transform: translateY(-10%);
    opacity: 0;
  }
}
</style>
